module.exports = __webpack_public_path__ + "img/grn_grom_the_paunch_0.c8cf1ca1.png";